import useGoalActivityRepo from '@/composables/goal-activity/goal-activity-repo';
import useGoals from '@/composables/goal/goals';

export default function useGoalActivity(shouldExclude) {
  const repo = useGoalActivityRepo(shouldExclude);
  const goalsSvc = useGoals();

  const increaseGoalActivitiesCount = (goalActivities) => {
    const goals = goalsSvc.selectMultiple(goalActivities.map((ga) => ga.goal?.uid));
    goals.forEach((g) => {
      goalsSvc.updateSingle({ uid: g.uid, goalActivityCount: g.goalActivityCount + 1 }, { commitToRemote: false });
    });
  };

  const decreaseGoalActivitiesCount = (goalActivities) => {
    const goals = goalsSvc.selectMultiple(goalActivities.map((ga) => ga.goal?.uid));
    goals.forEach((g) => {
      goalsSvc.updateSingle({ uid: g.uid, goalActivityCount: g.goalActivityCount - 1 }, { commitToRemote: false });
    });
  };

  return {
    ...repo,
    increaseGoalActivitiesCount,
    decreaseGoalActivitiesCount,
  };
}
